import { DialogMaster } from "#core/components/dialog/Dialog"
import InputNumber from "#core/components/input/number/InputNumber"
import InputSelect from "#core/components/input/select/InputSelect"
import { useApiSend } from "#hooks/useApiSend"
import { Box, Typography } from "@mui/material"
import { EVALUATOR_TYPE_LIST } from "Components/bajas/constants"
import { UseDialogBajaContext } from "Components/bajas/DialogDetailBaja/components/DialogBajaContext"
import { earningsIdPut } from "Components/bajas/services/api"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"

export function PerceptionsForm({ name, value, setValue }) {
	return (
		<Box sx={{ display: "grid", gap: 2, mt: 2 }}>
			<Typography variant="h6">{name}</Typography>
			<InputNumber
				label="Cantidad"
				value={value.amount}
				setValue={(e) => setValue({ ...value, amount: e })}
				fullWidth
			/>
			<InputSelect
				options={EVALUATOR_TYPE_LIST}
				optionsLabel="label"
				optionsId="id"
				label={"Tipo"}
				value={value.concept_type}
				setValue={(value) => setValue((old) => ({ ...old, concept_type: value }))}
			/>
		</Box>
	)
}

export default function PerceptionEdit({ open, setOpen, refresh, perception }) {
	const { baja } = UseDialogBajaContext()
	const [value, setValue] = useState({
		amount: perception.amount,
		concept_type: perception.concept_type,
	})
	const [disabled, setDisabled] = useState(false)
	useEffect(() => {
		setValue({ amount: perception.amount, concept_type: perception.concept_type })
	}, [perception])
	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(earningsIdPut, { success, end })
	const handleSubmit = () => {
		if (!value.amount) {
			toast.error("Se requiere un monto para la percepción")
			return
		}
		setDisabled(true)
		fetch(baja.id, perception.id, value)
	}
	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				title: "Editar Percepciones",
				maxWidth: "xs",
				handleSubmit,
				disabled,
			}}
		>
			<PerceptionsForm value={value} setValue={setValue} name={perception.name} />
		</DialogMaster>
	)
}
